module.exports = __webpack_public_path__ + "assets/adobe_caslon_pro.cc899199fbbedadb0e2fe5e3477b5124.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/adobe_caslon_pro.woff
// module id = 1135
// module chunks = 0